// VERSION 2.2 - Implementierung Spielmodi
// =============================================================================
//  KONSTANTEN: Spielmodi (Game Modes)
// =============================================================================
//  Zweck: Eine zentrale Liste aller möglichen Spielmodi/Disziplinen für Turniere.
// =============================================================================

export const GAME_MODES = [
  { key: 'CLASSIC_120', label: '120 Wurf Classic (4x30)' },
  { key: '100_WURF', label: '100 Wurf (2x50)' },
  { key: '200_WURF', label: '200 Wurf (4x50)' },
  { key: 'SPRINT', label: 'Sprint (2x20)' },
  { key: 'PAARBEWERB', label: 'Paarbewerb (2x120)' },
  { key: 'TANDEM', label: 'Tandem (2x60 geteilt)' },
];